export const sha256 = async (input: string) => {
    // 将输入字符串转换为 Uint8Array
    const encoder = new TextEncoder();
    const data = encoder.encode(input);

    // 使用 SubtleCrypto API 计算 SHA-256 哈希
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    // 将哈希结果转换为十六进制字符串
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');

    return hashHex;
};

export async function encryptString(input: string) {
    const encrypted = await sha256(`${input}Kl@rItY2025`);
    return encrypted;
}
